var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "watch-list-card" }, [
    _c("div", { staticClass: "watch-list-card__top" }, [
      _c("div", { staticClass: "watch-list-card__title" }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "watch-list-card__actions" },
        [
          _c(
            "nuxt-link",
            { staticClass: "view-card", attrs: { to: _vm.viewLink() } },
            [_vm._v("View")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "edit-card",
              on: {
                click: function ($event) {
                  _vm.editable = true
                },
              },
            },
            [_vm._v("Edit")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dell-card", on: { click: _vm.deleteItem } },
            [_vm._v("Delete")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "alerts-type" },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "" },
                  on: { change: _vm.itemSaved },
                  model: {
                    value: _vm.alertType,
                    callback: function ($$v) {
                      _vm.alertType = $$v
                    },
                    expression: "alertType",
                  },
                },
                _vm._l(_vm.alertTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.editable
      ? _c("div", { staticClass: "watch-list-card__bottom" }, [
          _c("div", { staticClass: "watch-list-card__edit-name" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editName,
                  expression: "editName",
                },
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.editName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.editName = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "save", on: { click: _vm.itemSaved } }, [
              _vm._v("Save"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  _vm.editable = false
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }